import { UnitTypes } from "@/constants/bodyMetrics";
import i18n from "@/localization/i18next";

const CM_INTO_INCHES = 2.54;
const INCHES_INTO_FEET = 12;

const MIN_HEIGHT_CM = 122;
const MAX_HEIGHT_CM = 231;

export const cmToFeet = (
    cm: number | null,
    precision = 0
): {
    feet: number | null;
    inches: number | null;
} => {
    if (!cm) {
        return {
            feet: null,
            inches: null,
        };
    }
    const value = cm / CM_INTO_INCHES;
    return {
        feet: Math.floor(value / INCHES_INTO_FEET),
        inches: +(value % INCHES_INTO_FEET).toFixed(precision),
    };
};

export const feetToCm = (feet: number, inches: number): number => {
    return feet * INCHES_INTO_FEET * CM_INTO_INCHES + inches * CM_INTO_INCHES;
};

export const formatHeight = (cm: number, units: UnitTypes, precision = 0): string => {
    if (units === UnitTypes.Imperial) {
        const { feet, inches } = cmToFeet(cm);
        return `${feet} ft ${inches} in`;
    }

    return `${cm.toFixed(precision)} cm`;
};

export const validateHeight = (value: number, units: UnitTypes): string | null => {
    if (Math.ceil(value) < MIN_HEIGHT_CM || Math.floor(value) > MAX_HEIGHT_CM) {
        return i18n.t("please_enter_value_between_error", {
            min: formatHeight(MIN_HEIGHT_CM, units),
            max: formatHeight(MAX_HEIGHT_CM, units),
        });
    }
    return null;
};

export const getMaxMinHeights = (units: UnitTypes) => ({
    min: formatHeight(MIN_HEIGHT_CM, units),
    max: formatHeight(MAX_HEIGHT_CM, units),
});
